<style lang="scss" scoped="true">
.product-comparision__row {
    width: auto;
}

.product-comparision__list-item:before {
    content: " " !important;
}

/*Mobile adjustements*/
@media only screen and (max-width: 767px) {

    .product-comparision {

        .parametric-intro {
            padding-top: 0;
        }
    }

    .product-comparision {

        .page-title {
            padding: 15px 0 !important;
        }
    }

    .product-comparision__content {
        margin-bottom: 36px;
        width: calc(100% + 15px);
    }
}

/*Tablet adjustements*/
@media only screen and (max-width: 992px) {

    .product-comparision__content {
        overflow-x: auto !important;
    }
}

thead.product-comparision__thead tr:nth-child(2) th {
    border-top: 1px solid #ddd;
}

.table-actions {
    vertical-align: top;
}

table.product-comparision__table {
    border: 0;
}

table.product-comparision__table thead tr:first-child .product-comparison-headers {
    position: relative;

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 23px;
        height: 2px;
        background: #ddd;
        width: 100%;
    }
}

table.product-comparision__table thead tr:first-child .product-comparison-headers:last-child:after {
    width: calc(100% - 23px);
}

table.product-comparision__table thead tr:not(:first-child) th:first-child,
table.product-comparision__table tbody tr td:first-child {
    border-left: 1px solid #ddd;
}

table.product-comparision__table thead tr:nth-child(2) th:first-child {
    border-left: 0;
}

table.product-comparision__table thead tr:nth-child(2) th {
    border-bottom: 1px solid #ddd;
}

table.product-comparision__table thead tr:not(:first-child) th:last-child,
table.product-comparision__table tbody tr td:last-child {
    border-right: 1px solid #ddd;
}

table.product-comparision__table thead tr:nth-child(2) th:last-child {
    border-right: 0;
}

table.product-comparision__table tbody tr:last-child td {
    border-bottom: 1px solid #ddd;
}

.product-comparision .btn-default {
    width: 100%;
}

.product-comparision__btn-group .button-special {
    width: 130px;

    &:hover {
        border: none !important;
    }
}

.product-comparision__list {
    padding: 0 10px 10px 23px;
    margin-bottom: 50px;
}

.product-comparision__list-item--main {
    padding: 0 10px 10px 23px !important;
    border-bottom: none !important;
}

.product-comparision__list {
    padding-top: 20px;
}

.parametric-intro {
    width: auto !important;
}

.product-comparision__recommended-driver .product-comparision__cell--bold {
    font-weight: 600;
    color: #000;
    min-width: 188px;
}

.product-comparision__table-row--bordered {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
}

.product-comparision__btn-group .button-special .btn {
    text-align: left;
}

.st0 {
    fill: none;
    stroke: #00A8E1;
    stroke-miterlimit: 10;
}

.st1 {
    fill: #FFFFFF;
}

.st2 {
    fill: #00A8E1;
}

.product-comparision__recommended-driver svg {
    height: 150px;
    display: inline-block;
    left: 432px;
    position: relative;
    transform: translateX(-50%);
    margin-bottom: 30px;

    @media (max-width: 767px) {
        margin-top: 20px;
    }
}

.product-heading {
    padding: 0 22px 10px;
    color: #00A8E1;
}

.product-comparison-headers {
    vertical-align: top;
    width: 249px;
}

.h-border-0 {
    border: none !important;
}

.product-comparision__recommended-driver .product-comparision__list-item--main {
    margin-bottom: 0;
}

.product-comparision__recommended-driver table.product-comparision__table thead tr:nth-child(2) .product-comparison-headers {
    position: relative;
}

.product-comparision__recommended-driver table.product-comparision__table thead tr:nth-child(2) .product-comparison-headers:last-child:after {
    width: calc(100% - 23px);
}

.product-comparision__recommended-driver table.product-comparision__table thead tr:nth-child(2) .product-comparison-headers:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 23px;
    height: 2px;
    background: #ddd;
    width: 100%;
}

.product-comparision__recommended-driver .product-comparision__list {
    padding: 16px 10px 10px 25px;
}

.p-top-0 {
    padding-top: 0;
}

.product-comparision__recommended-driver .product-comparision__list-subitem {
    font-weight: lighter;
}

.product-comparision__recommended-driver thead .product-comparision__list-item.product-comparision__list-item--main {
    padding: 16px 10px 16px 23px !important;
}

.product-comparision__recommended-driver .product-comparision__tbody tr:nth-child(odd) {
    background-color: #fff;
}

.product-comparision__recommended-driver .product-comparision__tbody tr:nth-child(even) {
    background-color: #F9F9F9;
}

.product-comparision__recommended-driver tbody .product-comparision__table-row {
    border-bottom: 1px solid #F2F2F2;
}

.product-comparision__recommended-driver tbody .product-comparision__table-row:last-child {
    border-bottom: none;
}

.myAmpleon .parametric-intro {
    padding-top: 25px;
}
</style>

<template>
    <div class="product-comparision product-comparision__recommended-driver">
        <div class="parametric-intro" v-if="!shownInPip">
            <h3 class="page-title">Recommended line-up</h3>
        </div>

        <div class="product-comparision__content">
            <svg x="0px" y="0px" viewBox="0 0 511 173" style="enable-background:new 0 0 511 173;">
                <g id="line">
                    <line class="st0" x1="0" y1="86.61" x2="400" y2="86.61"/>
                </g>
                <g id="triangle_1">
                    <g>
                        <polygon class="st1" points="56.5,29.98 155,86.61 56.5,143.25 		"/>
                        <path class="st2"
                              d="M57,30.84l96.99,55.77L57,142.39V30.84 M56,29.11v115l100-57.5L56,29.11L56,29.11z"/>
                    </g>
                </g>
                <g id="triangle_2" transform="matrix(1 0 0 1 -17 0)">
                    <g>
                        <polygon class="st1" points="305.5,0.98 454,86.61 305.5,172.25 		"/>
                        <path class="st2"
                              d="M306,1.85l147,84.77l-147,84.77V1.85 M305,0.11v173l150-86.5L305,0.11L305,0.11z"/>
                    </g>
                </g>
            </svg>
            <div class="product-comparision__row">
                <table class="product-comparision__table">
                    <thead class="product-comparision__thead">
                    <tr class="product-comparision__table-row">
                        <th class="table-actions" rowspan="3">
                            <div class="product-comparision__btn-group">
                                <div class="button-special">
                                    <a class="btn btn-default" id="save-excel" @click="downloadRecommendedExcel"
                                       role="button"><i class="lnr lnr-enter-down"></i> save to excel</a>
                                </div>
                                <div class="button-special" v-if="!shownInPip">
                                    <router-link class="btn btn-default"
                                                 :to="{path: isPublic ? '/' : '/my-parametric-search'}"><i
                                        class="lnr lnr-undo"></i> go back
                                    </router-link>
                                </div>
                            </div>
                        </th>
                        <th class="product-heading product-comparison-headers p-top-0">
                            Driver
                        </th>
                        <th class="product-heading product-comparison-headers p-top-0">
                            Final
                        </th>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <template v-if="isRecommendedDriverSucceeded">
                            <th class="product-comparison-headers h-border-0"
                                v-for="(product, index) in selectedProductParametrics.typeNumber">
                                <div class="product-comparision__list-item product-comparision__list-item--main">
                                    <a :href="selectedProductParametrics.productDetailsLink[index]"
                                       class="product-comparision__list-anchor">{{product}}</a>
                                    <span class="product-comparision__list-subitem">{{selectedProductParametrics.description[index]}}</span>
                                </div>
                            </th>
                        </template>
                        <template v-else-if="!isRecommendedDriverLoading">
                            <th>
                                <div class="product-comparision__list-item product-comparision__list-item--main">
                                    Internal error.
                                </div>
                            </th>
                        </template>
                    </tr>
                    <tr v-if="isRecommendedDriverSucceeded" class="product-comparision__table-row">
                        <td class="product-comparison-headers h-border-0"
                            v-for="(product, index) in selectedProductParametrics.typeNumber">
                            <ul class="product-comparision__list">
                                <li class="product-comparision__list-item">
                                    <a :href="selectedProductParametrics.productDetailsLink[index]"
                                       class="product-comparision__list-anchor">Product Details</a>
                                </li>

                                <li class="product-comparision__list-item">
                                    <a :href="selectedProductParametrics.dataSheetLink[index]"
                                       class="product-comparision__list-anchor">Datasheet</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="selectedProductParametrics.productDetailsLink[index] + '#ordering'"
                                       class="product-comparision__list-anchor">Sample / Buy</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="selectedProductParametrics.productDetailsLink[index] + '#documentation'"
                                       class="product-comparision__list-anchor">Documentation</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="selectedProductParametrics.productDetailsLink[index] + '#designsupportdocs'"
                                       class="product-comparision__list-anchor">Design Support</a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </thead>
                    <tbody v-if="isRecommendedDriverSucceeded" class="product-comparision__tbody">
                    <tr class="product-comparision__table-row--bordered">
                        <th class="product-comparision__th product-comparision__cell--bold first-column">Status</th>
                        <th v-for="(product, index) in selectedProductParametrics.status"
                            class="product-comparision__th">{{product}}
                        </th>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">Package outline</td>
                        <td v-for="(product, index) in selectedProductParametrics.packageName"
                            class="product-comparision__th">
                            <a :href="selectedProductParametrics.packageLink[index]">{{product}}</a></td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">F<sub>min</sub> (MHz)
                        </td>
                        <td v-for="product in selectedProductParametrics.frangeMin" class="product-comparision__th">
                            {{product}}
                        </td>

                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">F<sub>max</sub> (MHz)
                        </td>
                        <td v-for="product in selectedProductParametrics.frangeMax" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub v-if="this.powerLabelRD === 'ppeak'">peak</sub><sub v-else>L(1dB)</sub> (W)
                        </td>
                        <td v-for="product in selectedProductParametrics.pl1db" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub v-if="this.powerLabelRD === 'ppeak'">peak</sub><sub v-else>L(1dB)</sub> (dBm)
                        </td>
                        <td v-for="product in selectedProductParametrics.pl1dBdBm" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">V<sub>DS</sub> (V)</td>
                        <td v-for="product in selectedProductParametrics.vds" class="product-comparision__th">
                            {{product}}
                        </td>

                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">η<sub>D</sub> (%)</td>
                        <td v-for="product in selectedProductParametrics.nd" class="product-comparision__th">
                            {{product}}
                        </td>

                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">G<sub>P</sub> (dB)</td>
                        <td v-for="product in selectedProductParametrics.gp" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(AV)</sub> (W)
                        </td>
                        <td v-for="product in selectedProductParametrics.plav" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">Matching</td>
                        <td v-for="product in selectedProductParametrics.matchingValue" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">Test signal</td>
                        <td v-for="(product, index) in selectedProductParametrics.defaultTestSignal"
                            class="product-comparision__th">
                            <span class="product-comparision__select-wrapper">
                                <select v-model="selectedProducts[index].testSignal"
                                        class="product-comparision__select">
                                    <option v-bind:value="test_signal" v-for="(test_signal, index) in product"
                                            class="product-comparision__option">{{test_signal}}</option>
                                </select>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import {mapGetters} from "vuex";
import {FETCH_RECOMMENDED_PRODUCTS, DOWNLOAD_RECOMMENDED_EXCEL} from "../../store/actions.type";

export default {
    name: "RecommendedDriver",
    props: {
        isPublic: {
            type: Boolean
        },
        propRecommendedQueryParams: {
            type: String
        },
        propProductName: {
            type: String
        }
    },
    data() {
        return {
            //,
            typeNumberQueryParameters: [],
            actualProductParametrics: {
                typeNumber: [],
                description: [],
                productDetailsLink: [],
                dataSheetLink: [],
                orderInformationAvailable: [],
                status: [],
                packageName: [],
                packageLink: [],
                frangeMin: [],
                frangeMax: [],
                pl1db: [],
                pl1dBdBm: [],
                vds: [],
                nd: [],
                gp: [],
                plav: [],
                matchingValue: [],
                defaultTestSignal: [],
            },
            selectedProducts: [],
            productFromUrl: {
                typeNumber: "",
                testSignal: "",
            },
            shownInPip: false
        }
    },
    mounted() {
        this.typeNumberQueryParameters = new URLSearchParams();
        //console.log(`params:  ${typeof(this.recommendedQueryParams)} - ${this.productName}`);
        //Since the recommended driver page works with one product type number the query has to contain exactly one
        //product type number
        if ('string' === typeof (this.recommendedQueryParams)) {
            //the query params will be a string if you copy-paste the url
            //parsing the typeNumber from the url query
            this.productFromUrl.typeNumber = this.recommendedQueryParams.split('_')[0];
            this.productFromUrl.testSignal = this.recommendedQueryParams.split('_')[1];

            this.typeNumberQueryParameters.append('typeNumber', this.productFromUrl.typeNumber);
            //TODO functional NV: check if this is actually used.
        } else if ('object' === typeof (this.recommendedQueryParams) && this.recommendedQueryParams.length > 0) {
            //the query param will be an object (array) if the user comes through router push
            this.productFromUrl.typeNumber = this.recommendedQueryParams[0].split('_')[0];
            this.productFromUrl.testSignal = this.recommendedQueryParams[0].split('_')[1];
            this.typeNumberQueryParameters.append('typeNumber', this.productFromUrl.typeNumber);
        } else if (this.productName) {
            this.shownInPip = true;
            this.typeNumberQueryParameters.append('typeNumber', this.productName)
        }

        if(this.productCategory != null) {
          this.typeNumberQueryParameters.append('cat', this.productCategory);
        } else if(this.applicationCategory != null) {
          this.typeNumberQueryParameters.append('targetApplication', this.applicationCategory);
        }

        this.fetchRecommendedDriverProducts(this.typeNumberQueryParameters);

    },
    watch: {
        recommendedProducts: function (newVal, oldVal) { // watch it
            // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
            if (Object.keys(newVal).length > 0) {
                // Initializing the selected test signals for the dropdown whenever the fetched values,
                // (with the selected product - and the recommended driver for that product) changes

                //selecting exactly that product from the response values which has the same type number as in the url query
                const productFromQuery = _.pick(this.recommendedProducts, [this.productFromUrl.typeNumber]);

                for (const product in this.recommendedProducts) {
                    if (this.recommendedProducts.hasOwnProperty(product)) {
                        const actualProduct = this.recommendedProducts[product];
                        //when we have the product with the same type number as in the url query,
                        // pre-select it with the test signal from the url query
                        if (productFromQuery != null && productFromQuery.typeNumber === actualProduct.typeNumber) {
                            this.selectedProducts.push({
                                typeNumber: actualProduct.typeNumber,
                                testSignal: this.productFromUrl.testSignal,
                            })
                        } else {
                            this.selectedProducts.push({
                                typeNumber: actualProduct.typeNumber,
                                testSignal: Object.keys(actualProduct.productParametrics)[0],
                            })
                        }
                    }

                }
            }
        },
    },
    computed: {
        ...mapGetters(["isRecommendedDriverLoading", "recommendedProducts", "isRecommendedDriverSucceeded", "powerLabelRD"]),

        productCategory: function () {
          if (typeof pcat !== "undefined") {
            return pcat;
          } else {
            return null;
          }
        },

        applicationCategory: function () {
          if (typeof acat !== "undefined") {
            return acat;
          } else {
            return null;
          }
        },

        recommendedQueryParams() {
            return this.propRecommendedQueryParams;
        },

        productName() {
            return this.propProductName;
        },
        selectedProductParametrics: function () {
            if (Object.keys(this.recommendedProducts).length > 0) {
                this.emptyActualProductValues();
            } else {
                return false;
            }

            for (const productItem in this.recommendedProducts) {
                let actualProduct = this.recommendedProducts[productItem];

                //find the correct object in selectedProducts array of objects
                let selectedProductTestSignal = this.selectedProducts.find(product => product.typeNumber === actualProduct.typeNumber);
                if (selectedProductTestSignal) {
                    let actualProductParametrics = actualProduct.productParametrics[selectedProductTestSignal.testSignal];
                    if (actualProduct && actualProductParametrics) {
                        this.actualProductParametrics.typeNumber.push(actualProduct.typeNumber);
                        this.actualProductParametrics.description.push(actualProduct.description);
                        this.actualProductParametrics.productDetailsLink.push(actualProduct.productDetailsLink);
                        this.actualProductParametrics.dataSheetLink.push(actualProduct.dataSheetLink);
                        this.actualProductParametrics.orderInformationAvailable.push(actualProduct.orderInformationAvailable);

                        this.actualProductParametrics.status.push(actualProduct.status);
                        this.actualProductParametrics.packageName.push(actualProduct.productPackage.itemName);
                        this.actualProductParametrics.packageLink.push(actualProduct.productPackage.itemLink);

                        this.actualProductParametrics.frangeMin.push(actualProductParametrics.frangeMin);
                        this.actualProductParametrics.frangeMax.push(actualProductParametrics.frangeMax);
                        this.actualProductParametrics.pl1db.push(actualProductParametrics.pl1dB);
                        this.actualProductParametrics.pl1dBdBm.push(actualProductParametrics.pl1dBdBm);
                        this.actualProductParametrics.vds.push(actualProductParametrics.vds);
                        this.actualProductParametrics.nd.push(actualProductParametrics.nd);
                        this.actualProductParametrics.gp.push(actualProductParametrics.gp);
                        this.actualProductParametrics.plav.push(actualProductParametrics.plav);
                        this.actualProductParametrics.matchingValue.push(actualProduct.matching);
                        this.actualProductParametrics.defaultTestSignal.push(Object.keys(actualProduct.productParametrics))
                    }
                }
            }
            return this.actualProductParametrics;
        },
    },
    methods: {
        fetchRecommendedDriverProducts(queryParameters) {
            this.$store.dispatch(FETCH_RECOMMENDED_PRODUCTS, queryParameters);
        },

        emptyActualProductValues() {
            this.actualProductParametrics.typeNumber = [];
            this.actualProductParametrics.description = [];
            this.actualProductParametrics.productDetailsLink = [];
            this.actualProductParametrics.dataSheetLink = [];
            this.actualProductParametrics.orderInformationAvailable = [];
            this.actualProductParametrics.status = [];
            this.actualProductParametrics.packageName = [];
            this.actualProductParametrics.packageLink = [];
            this.actualProductParametrics.frangeMin = [];
            this.actualProductParametrics.frangeMax = [];
            this.actualProductParametrics.pl1db = [];
            this.actualProductParametrics.pl1dBdBm = [];
            this.actualProductParametrics.vds = [];
            this.actualProductParametrics.nd = [];
            this.actualProductParametrics.gp = [];
            this.actualProductParametrics.plav = [];
            this.actualProductParametrics.matchingValue = [];
            this.actualProductParametrics.defaultTestSignal = [];
        },

        downloadRecommendedExcel() {
            if (this.isRecommendedDriverSucceeded) {
                let excelQuery = new URLSearchParams();
                // build the query from all the product type numbers in order
                // to get the excel file with the recommended driver and the selected product
                for (const product in this.recommendedProducts) {
                    if (this.recommendedProducts.hasOwnProperty(product)) {
                        excelQuery.append('typeNumber', product);
                    }
                }
                if(this.productCategory != null) {
                  excelQuery.append('cat', this.productCategory);
                } else if(this.applicationCategory != null) {
                  excelQuery.append('targetApplication', this.applicationCategory);
                }
                excelQuery.append('parametricSearch', 'false');
                this.$store.dispatch(DOWNLOAD_RECOMMENDED_EXCEL, excelQuery);
            }
            return false;
        }
    }
}
</script>
